
import styled from "styled-components";
import { BsSearch } from 'react-icons/bs'
export const Container = styled.div`
    display: flex;
    flex-shrink:1;
`

export const GContainer = styled.div`
    margin-top:23px;
    display: grid;
    grid-template-columns: 15% 70% 15%;
    @media (max-width: 1824px) {
      grid-template-columns: 16.5% 63.5% 20% !important;
    }  
    @media (max-width: 1324px) {
        grid-template-columns: 20% 60% 20% !important;
      }  
     @media (max-width: 794px) {
        grid-template-columns: 20% 60% 20% !important;
      } 
`
export const Container1 = styled.div`
    display: flex;
    flex-shrink:1;

`

export const Heading = styled.div`
font-size: 27px;
font-weight: 600;
color: #57585c;
cursor:pointer;
margin:10px 0px 10px 0px;

@media (max-width: 1145px) {
    font-size: 24px !important;
    margin:10px 0px 10px 0px;
  } 
@media (max-width: 794px) {
    font-size: 21px !important;

  } 
`
export const Seachbar = styled.div`
position: relative;
width: 85%;
flex-shrink: 1;
flex-grow: 1;
background-color: white;
height: 35px;
cursor:pointer;
border: 1px solid #dddddd;
border-radius: 10px;
margin:10px 10px 10px 143px;
&:focus{
    border-color: black;
}
@media (max-width: 1525px) {
  width: 86% !important;
  margin:10px 10px 10px 120px;
} 
@media (max-width: 1325px) {
  width: 95% !important;
  margin:10px 10px 10px 35px;
} 

`

export const Input = styled.input`
    width: 80%;
    height:25px;
    border:none;
    outline: none;
    cursor:pointer;
    position: absolute;
    font-size: 11px;
    font-weight: 600;
    left:50px;
    top:4px;
    @media (max-width: 1145px) {
        width: 30% !important;
      } 
`
export const CustomBsSearch = styled(BsSearch)`
position: absolute;
top:9px;
left:15px;
width:40px
@media (max-width: 1145px) {
    width: 50% !important;
  } 
`